import { useRef, useState } from 'react';
import { useIsomorphicLayoutEffect } from '@direct-frontend/stdlib';
import { TOP_BAR_LAYOUT } from '../../constants';
import { type TopBarLayout } from '../../types';

type HeightMeasurement = {
    layout: TopBarLayout;
    height: number;
};

export const useMeasuredTopBarHeight = (layout: TopBarLayout) => {
    const topBarRef = useRef<HTMLDivElement>(null);
    const [measurement, setMeasurement] = useState<HeightMeasurement>();
    const isConfigured =
        layout === TOP_BAR_LAYOUT.ONBOARDING_WITH_CONFIGURED || layout === TOP_BAR_LAYOUT.AFTER_ONBOARDING_CONFIGURED;

    // Первый замер перед показом кадра задаёт правильные отступы для sticky-элементов.
    useIsomorphicLayoutEffect(() => {
        if (!isConfigured) {
            return;
        }

        const element = topBarRef.current;

        if (!element) {
            return;
        }

        // Текст и кнопка конфигурируемой растяжки могут менять высоту TopBar; она нужна sticky-элементам страницы.
        const measure = () => {
            const height = element.getBoundingClientRect().height;

            setMeasurement((previous) =>
                previous?.layout === layout && previous.height === height ? previous : { layout, height }
            );
        };

        measure();

        if (typeof ResizeObserver === 'undefined') {
            return;
        }

        const observer = new ResizeObserver(measure);

        observer.observe(element);

        return () => observer.disconnect();
    }, [isConfigured, layout]);

    const measuredHeight = isConfigured && measurement?.layout === layout ? measurement.height : undefined;

    return { topBarRef, measuredHeight };
};
